import { Epic, ofType } from 'redux-observable';
import { RootAction, RootState, Services } from 'typesafe-actions';
import { of, from } from 'rxjs';
import { catchError, switchMap, mergeMap } from 'rxjs/operators';
import { CreateInvitationRequest } from '@amzn/coral_com-amazon-passportusermanagementservice';
import {
  createInvitation,
  getInvitedUsersForLogisticsParty,
} from '../../../actions/userManagementActions';
import {
  CREATE_INVITATION_REQUEST,
  CREATE_INVITATION_SUCCESS,
  CREATE_INVITATION_FAILURE,
} from '../../../actions/userManagementActions/actionTypes';
import { addNotification } from '../../../actions/ui';
import {
  DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
  NotificationTypeEnum,
} from '../../../actions/ui/types';
import { errorBodyForCodeMap } from '../../../constants/error';

export const createInvitationEpic: Epic<
  RootAction,
  RootAction,
  RootState,
  Services
> = (action$, state$, { api }) =>
  action$.pipe(
    ofType(CREATE_INVITATION_REQUEST),
    switchMap((action) =>
      from(
        api.userManagementServices
          .createInvitation(action.payload as CreateInvitationRequest)
          .pipe(
            mergeMap((response) =>
              of(
                createInvitation.success(response.invitationId as string),
                getInvitedUsersForLogisticsParty.request({
                  logisticsPartyId: action.payload?.logisticsPartyId,
                }),
                addNotification({
                  type: NotificationTypeEnum.SUCCESS,
                  action: CREATE_INVITATION_SUCCESS,
                  body: 'create_invitation_notifications.success',
                  timeout: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
                })
              )
            ),
            catchError((err) => {
              const errBody = err?.receivedException?.exceptionDetails
                ?.errorCode
                ? errorBodyForCodeMap[
                    err.receivedException.exceptionDetails.errorCode
                  ] || ''
                : '';
              return of(
                createInvitation.failure(err),
                addNotification({
                  type: NotificationTypeEnum.ERROR,
                  action: CREATE_INVITATION_FAILURE,
                  body: errBody || 'create_invitation_notifications.failure',
                  timeout: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
                })
              );
            })
          )
      )
    )
  );

export default createInvitationEpic;
